module.exports = __webpack_public_path__ + "images/emoji/leo.6ce7b9fb046cc4747f95.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/leo.png
// module id = UMfR
// module chunks = 14